import { Tooltip } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button<{
  $buttonSize: number;
  $padding: number;
  $variant: 'default' | 'ghost';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => p.$buttonSize}px;
  height: ${(p) => p.$buttonSize}px;
  padding: ${(p) => p.$padding}px;
  border-radius: 8px;
  border: ${(p) => (p.$variant === 'ghost' ? 'none' : '1px solid var(--color-border, #dbeae3)')};
  background-color: ${(p) => (p.$variant === 'ghost' ? 'transparent' : 'var(--color-surface-raised, #ffffff)')};
  cursor: pointer;
  box-sizing: border-box;
`;

const StyledIcon = styled.img<{ $iconSize: number }>`
  width: ${(p) => p.$iconSize}px;
  height: ${(p) => p.$iconSize}px;
  object-fit: contain;
`;

export const IconButton = ({
  onClick,
  icon,
  alt,
  tooltip,
  ariaLabel,
  buttonSize = 44,
  iconSize = 24,
  variant = 'default',
}: {
  onClick: () => void;
  icon: string;
  alt: string;
  tooltip?: string;
  ariaLabel?: string;
  buttonSize?: number;
  iconSize?: number;
  variant?: 'default' | 'ghost';
}) => {
  const padding =
    variant === 'ghost' ? 0 : Math.max(0, Math.round((buttonSize - iconSize) / 2));
  return (
    <Tooltip title={tooltip}>
      <StyledButton
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
        $buttonSize={buttonSize}
        $padding={padding}
        $variant={variant}
      >
        <StyledIcon src={icon} alt={alt} $iconSize={iconSize} />
      </StyledButton>
    </Tooltip>
  );
};

export default IconButton;
